const VERIFICATION_DAILY_SIGN_IN_PRINT = 'Daily Sign In Print Icon Click';
const VERIFICATION_DAILY_SIGN_OFF_PRINT = 'Daily Sign Off Print';
const VERIFICATION_GPS_OUTSIDE_PROJECT_PRINT = 'GPS Outside Project Print Icon Click';
const VERIFICATION_GPS_DISABLE_PRINT = 'GPS Disable Print Icon Click';
const VERIFICATION_DAILY_SIGN_IN_EXPORT = 'Verification Daily Sign-In Exported';
const VERIFICATION_DAILY_SIGN_OFF_EXPORT = 'Verification Daily Sign-Off Exported';
const MORE_TIME_OFF_PRINT = 'Time Off Report Print Click';
const MORE_HOUR_METER_PRINT = 'Hour Meter Print Report Click';
const MORE_BREAK_HOURS_PRINT = 'Break Hours Print Icon Click';

const verificationAnalyticsConstants = {
  VERIFICATION_DAILY_SIGN_IN_PRINT,
  VERIFICATION_DAILY_SIGN_OFF_PRINT,
  VERIFICATION_GPS_OUTSIDE_PROJECT_PRINT,
  VERIFICATION_GPS_DISABLE_PRINT,
  VERIFICATION_DAILY_SIGN_IN_EXPORT,
  VERIFICATION_DAILY_SIGN_OFF_EXPORT,
  MORE_TIME_OFF_PRINT,
  MORE_HOUR_METER_PRINT,
  MORE_BREAK_HOURS_PRINT,
};

export default verificationAnalyticsConstants;

